export default "__VITE_ASSET___SLFD0Gz__"